import APIClient from '@/shared/http/clients/api'

const resourceName = 'conta' // 'account'
const APICore = process.env.APIBaseURLCore

const Get = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetLogged = (config = {}) => APIClient.get(`${APICore}/${resourceName}/logged`, config)
const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllPagingByName = (name, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/nome/${name}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetByEmployeeId = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/funcionario/${id}`, config)
const GetByUsername = (username, config = {}) => APIClient.get(`${APICore}/${resourceName}/username/${username}`, config)
const GetNotifications = (config = {}) => APIClient.get(`${APICore}/${resourceName}/notificacoes`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)
const UpdateNotification = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/notificacoes/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const GetCorretorByName = (nome, data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/getCorretorByName/${nome}`, data, config)
const PostAddConta = (funcionarioId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/PostContaGera/${funcionarioId}`, data, config)
const BloqueioZpag = (contaId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/BloqueioZpag/${contaId}`, data, config)
const ResetSenhaZpag = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/ResetSenhaZpag`, data, config)

const AccountRepository = {
  Get,
  GetLogged,
  GetAll,
  GetAllPaging,
  GetAllPagingByName,
  GetById,
  GetByEmployeeId,
  GetByUsername,
  Create,
  Update,
  UpdateNotification,
  GetCorretorByName,
  Delete,
  GetNotifications,
  PostAddConta,
  BloqueioZpag,
  ResetSenhaZpag
}

export default AccountRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/account.js